import { UserInvitePersonaType, UserSignupPersonaType } from "./persona-types";

export enum OnboardingTask {
  COMPLETE_PROFILE = "complete_profile",
  WATCH_GPT_VIDEO = "watch_gpt_video",
  WATCH_PROJECT_TUTORIAL = "watch_project_tutorial",
  EXPLORE_DEMO_TEAM = "explore_demo_team",
  CREATE_TEAM = "create_team",
  CREATE_ASSESSMENTS = "create_assessments",
  DISCOVER_RESOURCES = "discover_resources",
  REVIW_SAMPLE_PROJECT = "reviw_sample_project",
  CREATE_PROJECT = "create_project",
}

export const ONBOARDING_TASKS = [
  {
    id: OnboardingTask.COMPLETE_PROFILE,
    title_key: "onboarding.complete_profile_task",
    path: "/surveys",
    order: 1,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.CANDIDATE,
      UserInvitePersonaType.ORG_MEMBER,
      UserInvitePersonaType.TEAM_MEMBER,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.PERSONAL,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  {
    id: OnboardingTask.WATCH_GPT_VIDEO,
    title_key: "onboarding.watch_gpt_video_task",
    path: `/dashboard?modal=video_modal&videoId=1105709461&event=${OnboardingTask.WATCH_GPT_VIDEO}`,
    order: 2,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.CANDIDATE,
      UserInvitePersonaType.ORG_MEMBER,
      UserInvitePersonaType.TEAM_MEMBER,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.PERSONAL,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  {
    id: OnboardingTask.WATCH_PROJECT_TUTORIAL,
    title_key: "onboarding.watch_project_tutorial_task",
    path: `/dashboard?modal=video_modal&videoId=1105709461&event=${OnboardingTask.WATCH_PROJECT_TUTORIAL}`,
    order: 3,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  // {
  //   id: OnboardingTask.EXPLORE_DEMO_TEAM,
  //   title_key: "onboarding.explore_demo_team_task",
  //   path: "/teams/demo",
  //   order: 4,
  //   personas: [
  //     UserSignupPersonaType.DISCOVERY,
  //     UserSignupPersonaType.HIRING,
  //     UserSignupPersonaType.TEAM_DEVELOPMENT,
  //   ],
  // },
  {
    id: OnboardingTask.CREATE_TEAM,
    title_key: "onboarding.create_team_task",
    path: `/teams/?modal=NEW_TEAM&event=${OnboardingTask.CREATE_TEAM}`,
    order: 5,
    personas: [UserSignupPersonaType.TEAM_DEVELOPMENT],
  },
  // {
  //   id: OnboardingTask.CREATE_ASSESSMENTS,
  //   title_key: "onboarding.create_assessments_task",
  //   path: "/projects",
  //   order: 6,
  //   personas: [
  //     UserSignupPersonaType.PERSONAL,
  //     UserSignupPersonaType.DISCOVERY,
  //     UserSignupPersonaType.HIRING,
  //     UserSignupPersonaType.TEAM_DEVELOPMENT,
  //   ],
  // },
  {
    id: OnboardingTask.DISCOVER_RESOURCES,
    title_key: "onboarding.discover_resources_task",
    path: "/dashboard#resources",
    order: 7,
    personas: [
      UserInvitePersonaType.ADMIN,
      UserInvitePersonaType.CANDIDATE,
      UserInvitePersonaType.ORG_MEMBER,
      UserInvitePersonaType.TEAM_MEMBER,
      UserInvitePersonaType.PROJECT_ADMIN,
      UserSignupPersonaType.PERSONAL,
      UserSignupPersonaType.DISCOVERY,
      UserSignupPersonaType.HIRING,
      UserSignupPersonaType.TEAM_DEVELOPMENT,
    ],
  },
  // {
  //   id: OnboardingTask.REVIW_SAMPLE_PROJECT,
  //   title_key: "onboarding.review_sample_project_task",
  //   path: "/projects/demo",
  //   order: 8,
  //   personas: [
  //     UserSignupPersonaType.PERSONAL,
  //     UserSignupPersonaType.DISCOVERY,
  //     UserSignupPersonaType.HIRING,
  //   ],
  // },
  {
    id: OnboardingTask.CREATE_PROJECT,
    title_key: "onboarding.create_project_task",
    path: `/projects/?modal=NEW_PROJECT&event=${OnboardingTask.CREATE_PROJECT}`,
    order: 9,
    personas: [UserSignupPersonaType.HIRING],
  },
];
